import axios from "axios";

import { ciamAxiosInstance, trackAndTraceAxiosInstance, myDeliveriesAxiosInstance } from "../lib/axios";

let cancelToken;
const CMS_API_URL = window.cmsAPIBaseUrl;
const CMS_API_KEY = window.cmsAPISubscriptionKey;
const SERVICE_API_URL = window.intAPIBaseUrl;
const SERVICE_API_KEY = window.intAPISubscriptionKey;
const CIAM_BASE_URL = window.ciamBaseUrl;
const CIAM_APPLICATION_CODE = window.ciamApplicationCode;
const CAP_BASE_URL = window.capBaseUrl;
const APP_AFT_TOKEN = window.appMyAccLoginAFToken;
const AUTO_ADDRESS_BASE_URL = window.autoAddressBaseUrl;
const AUTO_ADDRESS_BASE_KEY = window.appMyDeliveriesAFinderKey;
const MY_DELIVERIES_BASE_URL = window.appMyDeliveriesAPI;

// Function that gets a new JWT seccurity token if it has expired
const getJWTInfo = async () => {
    if (!window.apgigya.jwtIsExpired()) {
        return true;
    }
    let res;
    // if the JWT has expired, call the JWT endpoint
    // https://developers.gigya.com/display/GD/accounts.getJWT+JS
    try {
        await new Promise(resolve => {
            window.apgigya.getSecurityToken({ callback: resolve });
        });
    } catch (err) {
        return res;
    }

    return res;
};

/**
 *
 * If a JWT token expired then the user will be unauthorised,
 * a request to get a new token will be made and the page reloaded
 * more information about JWT here: https://developers.gigya.com/display/GD/accounts.getJWT+JS
 */
const checkError = err => {
    if (err.response && err.response.status === 401) {
        return getJWTInfo(true).then(() => {
            // reload the page
            window.location.reload();
        });
    }
    return err;
};

const autoCompleteAddress = (address, callback) => {
    axios.get(`${AUTO_ADDRESS_BASE_URL}/autocomplete?key=${AUTO_ADDRESS_BASE_KEY}&address=${address}&addressProfileName=AnPostProfile&vanityMode=false`).then(response => {
        callback(response);
    });
};

const findAddressWithName = (address, callback) => {
    axios.get(`${AUTO_ADDRESS_BASE_URL}/findaddress?key=${AUTO_ADDRESS_BASE_KEY}&addressElements=true&address=${address}&addressProfileName=AnPostProfile&language=EN&limit=-1`).then(response => {
        callback(response);
    });
};

const findAddress = (addressId, callback) => {
    axios.get(`${AUTO_ADDRESS_BASE_URL}/findaddress?key=${AUTO_ADDRESS_BASE_KEY}&addressElements=true&addressId=${addressId}&addressProfileName=AnPostProfile&language=EN&limit=0`).then(response => {
        callback(response);
    });
};

const getProfile = async uid => {
    try {
        const res = await ciamAxiosInstance.get(`/Profile/get?UID=${uid}`);
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getUserAddresses = async uid => {
    try {
        const res = await axios.get(`${CIAM_BASE_URL}/Address/GetAll?UID=${uid}`, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APPLICATION_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put new address data to API
const addAddress = async data => {
    try {
        const res = await axios.post(`${CIAM_BASE_URL}/Address/Add`, data, {
            headers: {
                "ANP-APPLICATION-CODE": CIAM_APPLICATION_CODE,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put address data to API
const deleteAddress = async data => {
    try {
        const res = await axios.delete(
            `${CIAM_BASE_URL}/Address/Delete?UID=${data.UID}&id=${data.id}`,
            {
                headers: {
                    "ANP-APPLICATION-CODE": CIAM_APPLICATION_CODE,
                    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
                }
            },
            data
        );
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// call to put address data to API
const deletePhone = async data => {
    try {
        const res = await axios.delete(
            `${CIAM_BASE_URL}/Phone/Delete?UID=${data.uid}&number=${data.number}`,
            {
                headers: {
                    "ANP-APPLICATION-CODE": CIAM_APPLICATION_CODE,
                    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
                }
            },
            data
        );
        return res;
    } catch (err) {
        return checkError(err);
    }
};

// get a list of countries
const getCountries = async () => {
    try {
        const res = await axios.get(`${CAP_BASE_URL}/countries`, {
            headers: {
                "X-RequestVerificationToken": APP_AFT_TOKEN,
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getMobileNumber = async uid => {
    try {
        const res = await myDeliveriesAxiosInstance.get(`/api/customer/${uid}/mobilenumbers`);
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const addMobileNumber = async (uid, data) => {
    try {
        const res = await myDeliveriesAxiosInstance.post(`/api/customer/${uid}/mobilenumbers`, data);
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const deleteMobileNumber = async (params, data) => {
    try {
        const res = await axios.delete(
            `${MY_DELIVERIES_BASE_URL}/api/customer/${params.uid}/mobilenumbers/${params.id}`,
            {
                headers: {
                    Authorization: `${localStorage.getItem("JWTToken")}`,
                    Pragma: "no-cache"
                }
            },
            data
        );
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const requestValidationMobileNumber = async (uid, data) => {
    try {
        const res = await myDeliveriesAxiosInstance.post(`/api/customer/${uid}/mobilenumbers:requestvalidation`, data);
        return res;
    } catch (err) {
        return err;
    }
};

const getFaqHtml = async () => {
    try {
        const res = await axios.post(
            `${CMS_API_URL}/Content`,
            {
                contentPath: "/myAccount/My-deliveries/Content",
                contentFormat: "data",
                locale: "en-ie"
            },
            {
                headers: {
                    Authorization: `${localStorage.getItem("JWTToken")}`,
                    Pragma: "no-cache",
                    "Ocp-Apim-Subscription-Key": CMS_API_KEY
                }
            }
        );
        return res;
    } catch (err) {
        return err;
    }
};

const validateMobileNumber = async (uid, data) => {
    try {
        const res = await myDeliveriesAxiosInstance.post(`/api/customer/${uid}/mobilenumbers:validate`, data);
        return res;
    } catch (err) {
        return err;
    }
};

const getTrackingHistory = async (uid, trackingNumber) => {
    const oneItemHistory = trackingNumber ? `/${trackingNumber}` : "";

    try {
        const res = await myDeliveriesAxiosInstance.get(`/api/customer/${uid}/trackingitems${oneItemHistory}`);
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const createCustomer = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/customers`, data, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getAutoDib = async uid => {
    try {
        const res = await axios.get(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/autodib`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const createAutoDib = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/autodib`, data, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getDeliveryManager = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager:get`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const updateAutoDib = async (uid, data) => {
    try {
        const res = await axios.put(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/autodib`, data, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const deleteAutoDib = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/autodib:cancel`, data, {
            headers: {
                Authorization: `${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const searchStores = async (radius, lat, lng, service, type) => {
    const searchUrl = "/StoreLocator/Search";
    const queryParams = {
        radius,
        userLat: lat,
        userLon: lng,
        service,
        type
    };

    const buildQueryStringWithNoEmptyParams = params => {
        let queryString = "";
        Object.keys(params).forEach(key => {
            if (params[key] !== "" && params[key] !== undefined && params[key] !== null) {
                queryString += `${key}=${params[key]}&`;
            }
        });
        return queryString.slice(0, -1);
    };

    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("canceled");
    }

    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    try {
        const res = await axios.get(`${SERVICE_API_URL}${searchUrl}?${buildQueryStringWithNoEmptyParams(queryParams)}`, {
            cancelToken: cancelToken.token,
            headers: {
                "Ocp-Apim-Subscription-Key": SERVICE_API_KEY
            }
        });
        return res;
    } catch (err) {
        return err;
    }
};

// get Services
const getServices = async () => {
    const servicesUrl = "/StoreLocator/Services";

    try {
        const res = await axios.get(`${SERVICE_API_URL}${servicesUrl}`, {
            headers: {
                "Ocp-Apim-Subscription-Key": SERVICE_API_KEY
            }
        });
        return res;
    } catch (err) {
        return err;
    }
};

// get Towns in Ireland
const getTowns = async () => {
    const servicesUrl = "/StoreLocator/Towns";

    try {
        const res = await axios.get(`${SERVICE_API_URL}${servicesUrl}`, {
            headers: {
                "Ocp-Apim-Subscription-Key": SERVICE_API_KEY
            }
        });
        return res;
    } catch (err) {
        return err;
    }
};

const forAnotherDayReq = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager`, [data], {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const safeSpotReq = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager`, [data], {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const toANeighbourReq = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager`, [data], {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const parcelLockerReq = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager`, [data], {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const collectionPointReq = async (uid, data) => {
    try {
        const res = await axios.post(`${MY_DELIVERIES_BASE_URL}/api/customer/${uid}/deliverymanager`, [data], {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
                Pragma: "no-cache"
            }
        });
        return res;
    } catch (err) {
        return checkError(err);
    }
};

const getItemSummary = async data => {
    try {
        const res = await trackAndTraceAxiosInstance.post("/GetItemSummary", data);
        return res;
    } catch (err) {
        throw err;
    }
};

const getCustItemSummary = async data => {
    try {
        const res = await trackAndTraceAxiosInstance.post("/GetCustItemSummary", data);
        return res;
    } catch (err) {
        throw err;
    }
};

const getEvents = async data => {
    try {
        const res = await trackAndTraceAxiosInstance.post("/GetEvents", data);
        return res;
    } catch (err) {
        throw err;
    }
};

const checkDeliveredStatus = async data => {
    try {
        const res = await trackAndTraceAxiosInstance.post("/CheckStatusDelivered", data);
        return res;
    } catch (err) {
        throw err;
    }
};

export {
    autoCompleteAddress,
    findAddress,
    getProfile,
    addAddress,
    deleteAddress,
    deletePhone,
    getCountries,
    getJWTInfo,
    findAddressWithName,
    getMobileNumber,
    addMobileNumber,
    deleteMobileNumber,
    requestValidationMobileNumber,
    validateMobileNumber,
    getDeliveryManager,
    getTrackingHistory,
    getFaqHtml,
    createCustomer,
    getAutoDib,
    createAutoDib,
    updateAutoDib,
    deleteAutoDib,
    searchStores,
    getServices,
    getTowns,
    forAnotherDayReq,
    safeSpotReq,
    toANeighbourReq,
    parcelLockerReq,
    collectionPointReq,
    getUserAddresses,
    getItemSummary,
    getCustItemSummary,
    getEvents,
    checkDeliveredStatus
};
